import { commonUrl } from "common/constants/apiUrls";
import { postData } from "networkManager/NetworkManager";

export const contactMail = async (payload) => {
  return await postData(commonUrl.contactEmail, payload);
};
